module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/staff_profile/model_black-f396fc50a8f1229646a3f7e964ef65f7.png";